// JS FRONT OFFICE

import './_tools'

import noUiSlider from 'nouislider'
window.noUiSlider = noUiSlider